import React from 'react';
import commonFieldMapping from './commonFieldMapping';
import formsPatternFieldMapping from './formsPatternFieldMapping';

/** @param {WebComponentFieldProps} props */
export default function vaDateCommonFieldMapping(props) {
  const {
    description,
    textDescription,
    DescriptionField,
    uiOptions,
    index,
    childrenProps,
  } = props;

  const { formsPatternProps, formDescriptionSlot } =
    formsPatternFieldMapping(props);

  return {
    ...commonFieldMapping(props),
    ...formsPatternProps,
    minYear: uiOptions?.minYear,
    maxYear: uiOptions?.maxYear,
    customDayErrorMessage: uiOptions?.customDayErrorMessage,
    customMonthErrorMessage: uiOptions?.customMonthErrorMessage,
    customYearErrorMessage: uiOptions?.customYearErrorMessage,
    value:
      typeof childrenProps.formData === 'undefined'
        ? ''
        : childrenProps.formData,
    children: (
      <>
        {formDescriptionSlot}
        {textDescription && <p>{textDescription}</p>}
        {DescriptionField && (
          <DescriptionField options={uiOptions} index={index} />
        )}
        {!textDescription && !DescriptionField && description}
      </>
    ),
  };
}
